import { PiFilmSlateFill, PiFilmReel, PiFilmStripLight } from "react-icons/pi";
import { FaBoxArchive } from "react-icons/fa6";
import { CgProfile } from "react-icons/cg";
import { PiBellRingingBold } from "react-icons/pi";
import { LiaShoppingBasketSolid } from "react-icons/lia";
import { PiUsersThreeFill } from "react-icons/pi";
import { PiCreditCardLight } from "react-icons/pi";
import { BsCameraVideo, BsFillTvFill } from "react-icons/bs";
import { IconType } from "react-icons";
import { ProjectType } from "store/types/project";
import ENVS from "./envs";
import { WeekDay } from "store/types/enum";

export const CUSTOMER_SUCCESS_EMAIL = "customer.success@rivetai.com";
export const CUSTOMER_SUCCESS_MAILTO = `mailto:${CUSTOMER_SUCCESS_EMAIL}`;
import DollarSign from "assets/images/dollarSign.svg?react";
import EuroSign from "assets/images/euroSign.svg?react";
import SterlingSign from "assets/images/sterlingSign.svg?react";
import YenSign from "assets/images/yenSign.svg?react";
import FrancSign from "assets/images/francSign.svg?react";
import RubleSign from "assets/images/rubleSign.svg?react";
import RupeeSign from "assets/images/rupeeSign.svg?react";
import ZARSign from "assets/images/r.svg?react";
import { PATH_DASHBOARD } from "./urls";

export interface NavItem {
  icon: IconType;
  name: string;
  link?: string;
  onClick?: () => void;
  comingSoon?: boolean;
  nonEnterpriseOnly?: boolean;
  isDisabled?: boolean;
}

export const FEATURE_STATUS_COMPLETED = "completed";
export const FEATURE_STATUS_PENDING = "pending";
export const FEATURE_STATUS_RERUNNING = "rerunning";
export const FEATURE_STATUS_FAILED = "failed";
export const FEATURE_STATUS_CANCELLED = "cancelled";
const NOTIFICATIONS = "Notifications";
const PROFILE = "Profile";

export const formValidationMsg = {
  required: {
    companyName: "Company name is required.",
    email: "Email is required.",
    firstName: "First name is required.",
    jobTitle: "Job Title name is required.",
    lastName: "Last name is required.",
    password: "Password is required.",
    confirmPassword: "Confirm password is required.",
    confirmTerms: "Confirm RivetAI Terms & Policy.",
  },
  formatErr: {
    emailPattern: "Email is not valid.",
    passwordMinLengthError: "Password must be at least 8 characters long.",
    passwordMatchError: "Passwords must match.",
    passwordUppercaseCharacterRequirement: "Password must contain at least one uppercase letter.",
    passwordNumberRequirement: "Password must contain at least one number.",
    passwordSymbolRequirement: "Password must contain at least one symbol.",
  },
};

export const navBtn: NavItem[] = [
  {
    icon: PiFilmSlateFill,
    name: "Projects",
    link: PATH_DASHBOARD.dashboard,
  },
  {
    icon: FaBoxArchive,
    name: "Archive",
    link: PATH_DASHBOARD.archive,
  },
];

export const personalBtn: NavItem[] = [
  {
    icon: CgProfile,
    name: PROFILE,
  },
  {
    icon: PiBellRingingBold,
    name: NOTIFICATIONS,
  },
];
export const workspaceBtn: NavItem[] = [
  // {
  //   icon: RiSettings4Line,
  //   name: "General",
  // },
  {
    icon: PiUsersThreeFill,
    name: "Teammates",
    nonEnterpriseOnly: true,
  },
  {
    icon: PiCreditCardLight,
    name: "Billing",
  },
];

/**
 * @deprecated Use ApiErrorCode from config/errorCodes instead.
 * Kept for backward compatibility in tests; will be removed in a future release.
 */
export const serverErrorCode = {
  SUBSCRIPTION_ALREADY_CANCELLED: "SUBSCRIPTION_ALREADY_CANCELLED",
  MFA_INVALID_TOTP_TOKEN: "INVALID_TOTP_TOKEN",
  MFA_SESSION_EXPIRED: "SESSION_EXPIRED",
  LOGIN_TEMPORARY_LOCKOUT: "TEMPORARY_LOCKOUT",
  TRIAL_ALREADY_EXISTS: "TRIAL_ALREADY_EXISTS",
};

export const coverageConstants = {
  minTextLength: 150,
  maxTextLength: 25000,
};

export const maxUploadImageSizeInMb = 3;
export const allowedImageTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/svg",
  "image/webp",
];

export const toastMsg = {
  axiosErr: {
    networkError: "Network Error",
    noToken: "Token is not present",
    noSubscription: "Select a subscription plan",
  },
  genericServerErr: "Uh oh, something went wrong. please try again later.",
  serverErr: `Oops! We hit a snag. Please contact our support team at ${CUSTOMER_SUCCESS_EMAIL} for help.`,
  confirm: {
    email: "Please confirm your email in order to continue to the next steps.",
  },
  logIn: {
    success: "Login successful!",
    error: {
      exist: "Invalid email or password!",
      invalidPassword: "Invalid email or password!",
      temporaryLockout: "Your account is temporarily locked. Please try again later.",
    },
  },
  sso: {
    error: {
      exist: "No connected organization found with this email.",
    },
  },
  inviteTeam: {
    success: "Invitation Sent",
    emailNotSent:
      "Invitation created, but the email could not be sent. Cancel it and invite them again.",
    error: {
      noOpenSeat: "No open seat for this user",
      selfInvite: "Account owner is part of the team",
      duplicateInvite: "This user has already been invited to the team",
    },
  },
  logOut: {
    success: "Bye for now!",
    error: "Unable to log you out, stick with us a little longer and try again.",
  },
  register: {
    success: "Welcome aboard! Your account is now registered.",
    error: {
      unique: "Oops! That username is taken. Try another one.",
      connect: "Uh-oh! We're having trouble connecting. Please try again.",
    },
  },
  imageUpload: {
    error: {
      invalidFormat: `Invalid file format. Allowed formats: ${allowedImageTypes
        .map((type) => type.replace("image/", ""))
        .join(", ")}.`,
      largefile: `File size exceeds the maximum upload file size (${maxUploadImageSizeInMb}MB).`,
    },
  },
  profile: {
    updated: "Profile updated successfully!",
    error: {
      noupload: "Oops! Failed to upload new image file. Please try again",
      unique: "Oops! There was an error updating your data. Please try again",
    },
  },
  mfa: {
    disabled: "Multi-Factor authentication disabled successfully!",
    setupKeyCopied: "Setup key copied to clipboard!",
    error: {
      invalidToken: "The token is invalid",
      sessionExpired: "Session expired. Please try again",
    },
  },
  changePassword: {
    success: "Password updated successfully!",
    error: {
      default: "Oops! Unable to change current password. Please try again",
      invalid: "Oops! The current password you entered is incorrect. Please try again",
      notNew: "New password cannot be the same as old password.",
    },
  },
  upload: {
    success: "File uploaded successfully!",
    failed: "Oops! We hit a snag creating this project. Please try again.",
    processing: "Project creation in progress!",
  },
  resetPassword: {
    forgot: {
      success: "If an account exists for that email address, a password reset link has been sent.",
      error:
        "Hmm... We couldn't find an account with that email. Please double-check and try again.",
    },
    reset: {
      success: "Great! Your password has been updated.",
      error: {
        updated: "Oops! We couldn't update your password. Please try again.",
        token: "The password reset link seems to be expired or invalid. Please request a new one.",
      },
    },
  },
  verification: {
    resendEmail: {
      success: "An email confirmation has been sent. Please check your inbox and follow the steps.",
      error:
        "Hmm... We couldn't find an account with that email. Please double-check and try again.",
    },
    verifyAccount: {
      success: "Your account is now verified. Welcome onboard!",
      requestPattern: {
        general: "Sorry, we're facing issues verifying your account. Please try logging in again.",
        noUser:
          "The verification link doesn't match any account. Please double-check the link or sign up.",
        alreadyVerified: "This account has been verified previously.",
        alreadyActive: "This account is active and good to go.",
      },
    },
  },
  createProject: {
    fileUpload: {
      success: "Screenplay uploaded successfully",
      failed: "Oops! You uploaded a wrong file format. Please try again.",
      largefile: "Oops! Uploaded file exceeds the maximum upload file size (5MB).",
      noupload: "Please upload your project's screenplay script (.pdf, .fdx, .celtx, .fountain)",
      noname: "Oops! You didn't add a project name. Please try again.",
      nodescription: "Oops! You didn't add a brief description of your project.",
      notype: "Oops! You didn't add a project type. Pick from the options above",
      nofeature: "Oops! You did not pick a project feature from the options above",
    },
    complete: "Great! New project created successfully!",
    error: "Oops! An error occurred. Please try again!",
    nobudget:
      "Oops! To use the budget feature, you must set a valid max budget amount under advanced features.",
  },
  createAutomaticDayBreaks: {
    success: "Shoot days added successfully",
    error: {
      default: "Oops! An error occurred. Please try again!",
      invalidHours: "Hours should be a positive number.",
    },
  },
  reRunBudgeting: {
    success: {
      rebudgetFinishedSuccessfully: "Rebudgeting run successfully.",
      budgetReadySuccessfully: "Budget ready.",
    },
  },
  reRunScheduling: {
    success: {
      rescheduleFinishedSuccessfully: "Rescheduling run successfully.",
    },
    error: {
      default: "Oops! An error occurred. Please try again!",
      excludeWeekdaysLimit: "Choose at least 1 working day!",
      failedToStartReRun: "Rescheduling failed to start. Please try again.",
    },
  },
  stripboard: {
    duplicateScene: {
      success: "Scene duplicated successfully.",
    },
    deleteDayBreak: {
      success: "Shoot day removed successfully.",
    },
    deleteBanner: {
      success: "Banner deleted successfully.",
    },
    deleteScene: {
      success: "Scene deleted successfully.",
    },
    notes: {
      success: "Note saved successfully.",
    },
  },
  boneyard: {
    moveToBoneyard: {
      success: "Moved to Boneyard",
    },
    moveToStripBoard: {
      success: "Moved to Stripboard",
    },
  },
  manualDayBreak: {
    success: {
      create: "Shoot day added successfully.",
      update: "Shoot day updated successfully.",
    },
    error: "Oops! An error occurred. Please try again!",
    locked: "This shoot day is locked. Unlock it before changing its scenes or date.",
  },
  banner: {
    success: {
      create: "Banner added successfully.",
      update: "Banner updated successfully.",
    },
  },
  createNote: {
    success: "Note saved!",
    error: "Oops! An error occured. Please try again!",
  },
  upgrade: {
    cancelledSubscription:
      "We are unable to upgrade or downgrade because you have cancelled your subscription.",
  },
  coverage: {
    error: "Oops! An error occurred. Please try again!",
    smallText: `Provided text is too short. Please type at least ${coverageConstants.minTextLength} characters.`,
    longText: `Provided text is too long. Please cut down text to at most ${coverageConstants.maxTextLength} characters.`,
    summaryLongText: `Summary text is too long. Please cut down text to at most ${coverageConstants.maxTextLength} characters.`,
    commentsLongText: `Selected text is too long. Please cut down text to at most ${coverageConstants.maxTextLength} characters.`,
  },
};

export const DEFAULT_SEAT_NUMBER = 1;

export const priceData = [
  {
    interval: "",
    category: "Free",
    id: ENVS.freePlanId,
    seat: DEFAULT_SEAT_NUMBER,
    project: 1,
    price: "0",
    list: [
      "1 Project",
      "14 days max",
      "AI-powered Features:",
      [
        "Coverage",
        "Script Breakdown",
        "Character Breakdown",
        "Scheduling",
        "Budgeting",
        "Summary Reports",
      ],
      "Manual Edits",
    ],
  },
  {
    interval: "monthly",
    category: "Indie",
    id: ENVS.starterPlanId,
    price: "49",
    seat: 1,
    project: 3,
    list: [
      "5 Projects/Month",
      "Team Access (+1 Free Seat)",
      "AI-Powered Features",
      [
        "Coverage",
        "Script Breakdown",
        "Character Breakdown",
        "Scheduling",
        "10 Scheduling Re-Runs/Month",
        "Budgeting",
      ],
      "Summary Reports",
      "Real-time Collaboration",
      "Manual Edits",
      "Exports (FDX, PDF, CSV)",
      "Export to Movie Magic Scheduling",
      "Optional Add-Ons",
    ],
  },
  {
    interval: "monthly",
    category: "Studio",
    id: ENVS.indiePlanId,
    price: "199",
    seat: 5,
    project: 10,
    list: [
      "20 Projects/Month",
      "Team Access (+9 Free Seats)",
      "AI-Powered Features:",
      [
        "Coverage",
        "Script Breakdown",
        "Character Breakdown",
        "Scheduling",
        "∞ Scheduling Re-Runs/Month",
        "Budgeting",
      ],
      "Summary Reports",
      "Real-time Collaboration",
      "Manual Edits",
      "Exports (FDX, CSV, PDF)",
      "Export to Movie Magic Scheduling",
      "Optional Add-Ons",
    ],
  },
  {
    interval: "yearly",
    category: "Indie",
    id: ENVS.starterPlanId,
    seat: 1,
    project: 3,
    price: "39",
    list: [
      "5 Projects/Month",
      "Team Access (+1 Free Seat)",
      "AI-Powered Features",
      [
        "Coverage",
        "Script Breakdown",
        "Character Breakdown",
        "Scheduling",
        "10 Scheduling Re-Runs/Month",
        "Budgeting",
      ],
      "Summary Reports",
      "Real-time Collaboration",
      "Manual Edits",
      "Exports (FDX, PDF, CSV)",
      "Export to Movie Magic Scheduling",
      "Optional Add-Ons",
    ],
  },
  {
    interval: "yearly",
    category: "Studio",
    id: ENVS.indiePlanId,
    seat: 5,
    project: 10,
    price: "149",
    list: [
      "20 Projects/Month",
      "Team Access (+9 Free Seats)",
      "AI-Powered Features:",
      [
        "Coverage",
        "Script Breakdown",
        "Character Breakdown",
        "Scheduling",
        "∞ Scheduling Re-Runs/Month",
        "Budgeting",
      ],
      "Summary Reports",
      "Real-time Collaboration",
      "Manual Edits",
      "Exports (FDX, CSV, PDF)",
      "Export to Movie Magic Scheduling",
      "Optional Add-Ons",
    ],
  },
  {
    interval: "",
    category: "Enterprise",
    list: [
      "Customizable Seats",
      "Customizable Projects",
      "AI-Powered Features:",
      [
        "Coverage",
        "Script Breakdown",
        "Character Breakdown",
        "Scheduling",
        "∞ Scheduling Re-Runs/Month",
        "Budgeting",
      ],
      "Summary Reports",
      "Real-time Collaboration",
      "Manual Edits",
      "Exports",
      "Export to Movie Magic Scheduling",
      "Exclusive Enterprise-Level Services:",
      ["Logo Removal", "Domain Customization", "Custom AI Models"],
    ],
  },
];

export const budgetNonEditableReasons = {
  deleteCategory: "You don't have permissions to delete the category.",
  deleteSubCategory: "You don't have permissions to delete the subcategory.",
  viewer: "You don't have permissions to edit the budget.",
  expandedAccount:
    "This value can't be edited directly because it's an expanded account. Click the blue description to open details which can be edited.",
  importanceOnSubcategory: "Importance can be set only on the account level.",
  variance: "Remaining vs estimate is calculated and is not editable.",
  total: "The total is calculated and is not editable.",
  contingencyEstimate: "Edit the contingency percentage to change the contingency estimate.",
  accountNumber: "The account number is not editable.",
  accountDescription: "The account description is not editable.",
  budgetLocked: "Estimate is locked. Unlock to edit structure, rates, and assumptions.",
  lockedAccount: "This account is pinned for Rebudget and can't be edited.",
  estimate: "The estimate can't be edited directly. Use 'Qty' and 'Rate' columns instead.",
  fringesField: "Change fringes on the Fringes page or in the Fringes column of each line.",
};

// STATIC DATA FOR PROJECT CREATION
export const projectTypesData: ProjectType[] = [
  {
    name: "Short Film",
    key: "short",
    active: true,
    icon: BsCameraVideo,
    description: "Under 40 minutes in length",
  },
  {
    name: "Independent",
    key: "feature",
    active: true,
    icon: PiFilmSlateFill,
    description: "Full-length movie, produced outside major film studios",
  },
  {
    name: "Studio",
    key: "studio",
    active: true,
    icon: PiFilmReel,
    description: "High-budget, studio-backed major production",
  },
  {
    name: "Documentary",
    key: "documentary",
    active: false,
    icon: PiFilmStripLight,
    description: "Non-fiction film exploring real stories and issues",
  },
  {
    name: "Commercial",
    key: "commercial",
    active: false,
    icon: LiaShoppingBasketSolid,
    description: "Creative content for marketing and advertising purposes",
  },
  {
    name: "TV",
    key: "other",
    active: false,
    icon: BsFillTvFill,
    description: "Episodic or serialized content designed for television",
  },
];

export type Production_Type_Filter_Values = "" | "feature" | "short" | "studio";

export enum ProductionState {
  Alaska = "Alaska",
  Alabama = "Alabama",
  Arkansas = "Arkansas",
  Arizona = "Arizona",
  California = "California",
  Colorado = "Colorado",
  Connecticut = "Connecticut",
  DistrictOfColumbia = "District of Columbia",
  Delaware = "Delaware",
  Florida = "Florida",
  Georgia = "Georgia",
  Hawaii = "Hawaii",
  Iowa = "Iowa",
  Idaho = "Idaho",
  Illinois = "Illinois",
  Indiana = "Indiana",
  Kansas = "Kansas",
  Kentucky = "Kentucky",
  Louisiana = "Louisiana",
  Maryland = "Maryland",
  Maine = "Maine",
  Massachusetts = "Massachusetts",
  Michigan = "Michigan",
  Minnesota = "Minnesota",
  Missouri = "Missouri",
  Mississippi = "Mississippi",
  Montana = "Montana",
  NorthCarolina = "North Carolina",
  NorthDakota = "North Dakota",
  Nebraska = "Nebraska",
  NewHampshire = "New Hampshire",
  NewJersey = "New Jersey",
  NewMexico = "New Mexico",
  Nevada = "Nevada",
  NewYork = "New York",
  Ohio = "Ohio",
  Oklahoma = "Oklahoma",
  Oregon = "Oregon",
  Pennsylvania = "Pennsylvania",
  PuertoRico = "Puerto Rico",
  RhodeIsland = "Rhode Island",
  SouthCarolina = "South Carolina",
  SouthDakota = "South Dakota",
  Tennessee = "Tennessee",
  Texas = "Texas",
  Utah = "Utah",
  Virginia = "Virginia",
  Vermont = "Vermont",
  Wisconsin = "Wisconsin",
  WestVirginia = "West Virginia",
  Wyoming = "Wyoming",
  Other = "Other",
}
export const ProductionTypeProjectFilters: { [key: string]: Production_Type_Filter_Values } = {
  "All Projects": "",
  "Independent": "feature",
  "Short": "short",
  "Studio": "studio",
};

export const projectFeaturesData = [
  {
    name: "Coverage",
    text: "Detailed script coverage, providing an objective analysis including a logline, summary, and comments to enhance script development.",
  },
  {
    name: "Character breakdown",
    text: "In-depth analysis of each character's profile detailing physical and behavioral traits, appearance, and more.",
  },
  {
    name: "Script breakdown",
    text: "Automatic tagging of all production elements that make up a scene breakdown such as characters, props, costumes, and more.",
  },
  {
    name: "Budget",
    text: "Optimized top-sheet budget estimates, effectively allocating resources to align your production goals with financial capabilities.",
  },
  {
    name: "Schedule",
    text: "Automated stripboard and shooting calendar view, arranged for maximum efficiency and cost reduction in your production schedule.",
  },
];

export const projectCreationSubHeaderMsgs = {
  1: "Get started by uploading your screenplay",
  2: "Select what type of project you are creating",
  3: "Select features for AI-driven auto-fill, or leave unselected for your manual input later",
};

export const tooltips = {
  freePlan: {
    upgradeSubscription: "Upgrade subscription to access this feature",
  },
  canceledSubsription: {
    reactivatePlan: "You must reactivate your plan",
  },
  upgrade: {
    maxReached: "Max projects upgrade reached",
  },
  filters: {
    defaultSelected: "Default filters are already applied",
  },
  featureComingSoon: "Feature coming soon",
};

export interface HeaderItemTab {
  title: string;
  comingSoon?: boolean;
}

export const projectHeaderData = [
  {
    key: "script",
    name: "Script",
    tabs: [
      { title: "Breakdown" },
      { title: "Coverage" },
      { title: "Report" },
      { title: "Tags" },
      { title: "Notes" },
    ],
  },
  {
    key: "characters",
    name: "Characters",
    tabs: [{ title: "Breakdown" }, { title: "Summary" }, { title: "Actors" }],
  },
  {
    key: "schedule",
    name: "Schedule",
    tabs: [{ title: "Stripboard" }, { title: "Shooting Calendar" }, { title: "Day Out of Days" }],
  },
  {
    key: "budget",
    name: "Budget",
    tabs: [{ title: "Budget Breakdown" }, { title: "Actuals" }, { title: "Tax Incentives" }],
  },
];

// export const characterBreakdownCardData = {
//   "Basic Info": ["Full Name", "Nickname", "Age", "Date of Birth", "Gender", "Sexual Orientation", "Nationality / Culture", "Current Residence"],
//   "Physical Appearance": ["Race", "Skin Color", "Hair Color", "Eye Color", "Height", "Weight", "Significant Props", "Significant Costume"],
//   "Personality": ["Introvert / Extrovert", "Hero / Villain", "Speech / Accent", "Identity Traits", "Behavioural Traits"],
//   "Inner Psyche": ["Psychological State", "Ambitions / Goals", "Hope / Fears", "Religion / Sprituality", "Private Emotions"],
//   "Additional Details": ["Family / Friends", "Living Environment", "Career / Work", "Memories / Past", "Other Notes"]
// }

export const characterSummaryTableKeyVal: any = {
  name: "Character",
  hero_villain: "Role",
  gender: "Gender",
  nationality_culture: "Ethnicity",
  age: "Age",
  career_work: "Occupation",
  sexual_orientation: "Orientation",
  dialogue_count: "Dialogues",
  scene_count: "Scenes",
};

export const characterSummaryCols = [
  "name",
  "hero_villain",
  "gender",
  "nationality_culture",
  "age",
  "career_work",
  "sexual_orientation",
  "dialogue_count",
  "scene_count",
];

export const characterBreakdownCardData = {
  basic_info: [
    { name: "Name" },
    { full_name: "Full Name" },
    { age: "Age" },
    { date_of_birth: "Date of Birth" },
    { gender: "Gender" },
    { sexual_orientation: "Sexual Orientation" },
    { nationality_culture: "Nationality / Culture" },
    { current_residence: "Current Residence" },
  ],
  physical_appearance: [
    { race: "Race" },
    { skin_color: "Skin Color" },
    { height: "Height(m)" },
    { weight: "Weight(kg)" },
    { hair_color: "Hair Color" },
    { eye_color: "Eye Color" },
    { significant_props: "Significant Props" },
    { significant_costume: "Significant Costume" },
  ],
  personality: [
    { introvert_extrovert: "Introvert / Extrovert" },
    { hero_villain: "Hero / Villain" },
    { speech_accent: "Speech / Accent" },
    { identity_traits: "Identity Traits" },
    { behavioral_traits: "Behavioral Traits" },
  ],
  inner_psyche: [
    { psychological_state: "Psychological State" },
    { ambitions_goals: "Ambitions / Goals" },
    { hope_fears: "Hope / Fears" },
    { religion_spirituality: "Religion / Sprituality" },
    { private_emotions: "Private Emotions" },
  ],
  additional_details: [
    { family_friends: "Family / Friends" },
    { living_environment: "Living Environment" },
    { career_work: "Career / Work" },
    { memories_past: "Memories / Past" },
    { other_notes: "Other Notes" },
  ],
};

export const CoverageRows = [
  { Premise: "premise" },
  { Plot: "plot" },
  { "Production Value": "production_value" },
  { Characters: "characters" },
  { Setting: "setting" },
  { Structure: "structure" },
  { "Casting Potential": "casting_potential" },
];

export const coverageExportData = {
  info: {
    submitted_by: "Submitted By",
    created_at: "Created At",
    coverage_date: "Coverage Date",
    submitted_to: "Submitted To",
    author: "Author",
    length: "Length (scenes)",
    estimated_duration: "Estimated Duration",
    location: "Location",
    budget: "Budget",
    reader: "Reader",
    similar_projects: "Similar Projects",
    genre: "Genre",
  },
};

export const StripbordTableColumns = [
  "Scene #",
  "I/E & Day",
  "Set",
  "Cast ID",
  "Shooting Location",
  "Pages",
  "Est. Time",
];

export { helpArticleUrls } from "./helpArticleUrls";

export const profileLinks = {
  help: "https://www.help.rivetai.com",
  bookAMeeting: "https://calendly.com/rivetai",
};

export const WeekDays = [
  WeekDay.Sunday,
  WeekDay.Monday,
  WeekDay.Tuesday,
  WeekDay.Wednesday,
  WeekDay.Thursday,
  WeekDay.Friday,
  WeekDay.Saturday,
];

/** Default working-days selection for schedule/day-break modals (weekends unselected). */
export const DefaultScheduleWorkingDays = WeekDays.filter(
  (d) => d !== WeekDay.Saturday && d !== WeekDay.Sunday
);

// Intentionally no client-side dunning window constant. Stripe owns how long payments are
// retried and that is configurable in its dashboard, so any number duplicated here drifts
// silently. The server sends `subscription.is_entitled`; show that rather than a guessed date.

export const ProjectBudgetRanges = [
  {
    value: 35000,
    label: "35K-500K",
    minBudget: 35000,
    maxBudget: 500000,
  },
  {
    value: 500000,
    label: "500K-1M",
    minBudget: 500000,
    maxBudget: 1000000,
  },
  {
    value: 1000000,
    label: "1M-5M",
    minBudget: 1000000,
    maxBudget: 5000000,
  },
  {
    value: 5000000,
    label: "5M-10M",
    minBudget: 5000000,
    maxBudget: 10000000,
  },
  {
    value: 10000000,
    label: "10M-15M",
    minBudget: 10000000,
    maxBudget: 15000000,
  },
  {
    value: 15000000,
    label: "15M-30M",
    minBudget: 15000000,
    maxBudget: 30000000,
  },
  {
    value: 30000000,
    label: "30M-50M",
    minBudget: 30000000,
    maxBudget: 50000000,
  },
  {
    value: 50000000,
    label: "50M-100M",
    minBudget: 50000000,
    maxBudget: 100000000,
  },
  {
    value: 100000000,
    label: "100M+",
    minBudget: 100000000,
  },
];

export { NOTIFICATIONS, PROFILE };

export const CURRENCIES = [
  {
    name: "United States Dollar",
    abbreviation: "USD",
    symbol: "$",
    icon: DollarSign,
  },
  {
    name: "Euro",
    abbreviation: "EUR",
    symbol: "€",
    icon: EuroSign,
  },
  {
    name: "British Pound",
    abbreviation: "GBP",
    symbol: "£",
    icon: SterlingSign,
  },
  {
    name: "Australian Dollar",
    abbreviation: "AUD",
    symbol: "$",
    icon: DollarSign,
  },
  {
    name: "New Zealand Dollar",
    abbreviation: "NZD",
    symbol: "$",
    icon: DollarSign,
  },
  {
    name: "Canadian Dollar",
    abbreviation: "CAD",
    symbol: "$",
    icon: DollarSign,
  },
  {
    name: "Japanese Yen",
    abbreviation: "JPY",
    symbol: "¥",
    icon: YenSign,
  },
  {
    name: "Swiss Franc",
    abbreviation: "CHF",
    symbol: "CHF",
    icon: FrancSign,
  },
  {
    name: "Chinese Yuan",
    abbreviation: "CNY",
    symbol: "¥",
    icon: YenSign,
  },
  {
    name: "Mexican Peso",
    abbreviation: "MXN",
    symbol: "$",
    icon: DollarSign,
  },
  {
    name: "Indian Rupee",
    abbreviation: "INR",
    symbol: "₹",
    icon: RupeeSign,
  },
  {
    name: "Argentine Peso",
    abbreviation: "ARS",
    symbol: "$",
    icon: DollarSign,
  },
  {
    name: "Russian Ruble",
    abbreviation: "RUB",
    symbol: "₽",
    icon: RubleSign,
  },
  {
    name: "Colombian Peso",
    abbreviation: "COP",
    symbol: "$",
    icon: DollarSign,
  },
  {
    name: "South African Rand",
    abbreviation: "ZAR",
    symbol: "R",
    icon: ZARSign,
  },
];
